import { isGigPaused } from '../gigStatus';

export const shouldShowSelectPackage = ({ gigStatus, traffiqed, isOnVacation }) =>
    !(isGigPaused(gigStatus, traffiqed) || isOnVacation);
